import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API_HOST}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('HTwater.token');
    const deptId = localStorage.getItem('setDeptId'); //取localStorage中deptId

    config.headers['Authorization'] = `Bearer ${token}`;
    config.params = { ...config.params, dept: deptId };

    // 追蹤使用者最後活動日期，避免對 last-active 本身重複觸發
    if (token && !config.url.includes('last-active')) {
      // 用本地時間取日期，避免 toISOString() 回傳 UTC 造成台灣時區日期偏差
      const today = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD (本地時區)
      if (sessionStorage.getItem('last_active_date') !== today) {
        sessionStorage.setItem('last_active_date', today);
        axiosInstance.patch('last-active').catch(() => {
          // API 失敗時移除 sessionStorage，讓下次請求可以重試
          sessionStorage.removeItem('last_active_date');
        });
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      localStorage.removeItem('HTwater.token');
      window.location.href = '/pages/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;